// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".supervisor-checklist-header {\n  padding: 10px 14px;\n  font-size: 1rem;\n}", ""]);
// Exports
module.exports = exports;
